module.exports = __webpack_public_path__ + "static/media/01-Chelsea.d9b8261f.mp4";